/**
 * ThinkingIndicator / SSE progress-update display helpers.
 *
 * Cortex streams transient `progress_update` strings (connecting, running * script,
 * preparing tools, etc.). Horizon shows them in ThinkingIndicator while a turn runs.
 *
 * Use cases:
 * - Apply ordinary progress before any assistant text (classic thinking timeline).
 * - Keep applying progress after mid-turn assistant text (goal-before-tools), so
 *   connecting / running-script animated steps still appear.
 * - Suppress noisy lifecycle labels such as "disconnecting".
 */

/**
 * Returns true when a streamed progress update should update thinking steps.
 * Progress must remain visible for the whole active stream — not only before the
 * first assistant chunk — because the agent may narrate a short goal before tools.
 */
export function shouldApplyThinkingProgressUpdate(update: unknown): boolean {
  if (update == null) {
    return false;
  }
  if (typeof update !== "string") {
    return true;
  }
  const normalized = update.trim().toLowerCase();
  if (!normalized) {
    return false;
  }
  // SSH/session teardown noise — never surface as a thinking step.
  if (normalized === "disconnecting") {
    return false;
  }
  return true;
}
